export default {"src":"/_next/static/image/public/images/ic_error_graphic.e6318dce322ffd14bc8bf7111470d2d7.svg","height":274,"width":553};